<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="images/img-9-1.jpg" src="images/img-9-1.jpg"/></p>
<p class="ct2" id="pz21-1"><a href="#/contents#aa_p1" id="bb_p1">PART 1</a></p>
<p class="ct3"><a href="#/contents#aa_p1"><b>LIVING IN FEAR: MY STORY</b></a></p>
<p class="tx1" id="pz21-4">I want to share my story with you through the filter of my fear. My desire before I offer help, counsel, and ministry is to open up and allow you to hear my pain, my struggles, and what this battle with fear has created in my own life.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?18ff3ee6